const FILES = {
  hero: ["dachdecker-schifferstadt-ziegeldach", 2000, 1333, 1000],
  "tiles-wave": ["dacheindeckung-tonziegel", 1600, 1067],
  "frame-house": ["dachsanierung-dachstuhl", 1600, 1067],
  roofer: ["dachreparatur-dachdecker", 1600, 1067],
  "copper-gutter": ["dachrinne-kupfer", 1600, 1066],
  "copper-seam": ["kupferdach-stehfalz", 1600, 2400],
  skylights: ["dachfenster-einbau", 1600, 1067],
  "red-roofs": ["sturmschaden-ziegeldach", 1600, 967],
  beams: ["dachbegradigung-sparren", 1600, 2000],
  slate: ["dachcheck-schieferdach", 1600, 1067],
  "roofers-slate": ["dachdecker-schieferdach", 1600, 1060],
  dormers: ["gaubendach-sanierung", 1600, 902],
  timber: ["dachstuhl-holzkonstruktion", 1600, 1067],
  fachwerk: ["fachwerkhaus-bedachung", 1600, 2400],
  "flat-roof": ["flachdachabdichtung-bitumen", 1600, 2133],
};

export const imgFile = (name) => `/img/${FILES[name][0]}.webp`;

export const imgSrc = (name) => {
  const [file, w, h, sm = 800] = FILES[name];
  return { src: `/img/${file}.webp`, srcSet: `/img/${file}-sm.webp ${sm}w, /img/${file}.webp ${w}w`, width: w, height: h };
};

export const Pic = ({ name, alt, sizes = "(max-width: 768px) 100vw, 50vw", className = "", eager = false, ...rest }) => (
  <img {...imgSrc(name)} sizes={sizes} alt={alt} loading={eager ? "eager" : "lazy"} decoding="async" className={className} {...rest} />
);
